// @ts-strict
import {type ReactElement} from 'react';
import useTranslation from 'next-translate/useTranslation';

import SelectField from '../../SelectField';
import TextField from '../../TextField';
import {getCategoryLevel1Options} from '../utils';

const Step1ContactAndCategory = (): ReactElement => {
  const {t} = useTranslation('common');

  return (
    <div className="flex flex-col gap-4" data-testid="support-message-step-1">
      <div className="flex flex-col gap-4 tablet:flex-row tablet:gap-4">
        <div className="tablet:flex-1">
          <TextField
            name="contactName"
            label={t('components.SupportMessage.fields.contactName')}
            maxLength={80}
            testId="support-message-contactName"
          />
        </div>
        <div className="tablet:flex-1">
          <TextField
            name="email"
            label={t('components.SupportMessage.fields.email')}
            maxLength={80}
            testId="support-message-email"
          />
        </div>
      </div>
      <SelectField
        name="categoryLevel1"
        label={t('components.SupportMessage.fields.categoryLevel1')}
        options={getCategoryLevel1Options(t)}
        placeholder={t('components.SupportMessage.placeholders.none')}
        testId="support-message-categoryLevel1"
      />
    </div>
  );
};

export default Step1ContactAndCategory;
